import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Router,ActivatedRoute,Params,NavigationEnd,RoutesRecognized } from '@angular/router';
declare var $: any;
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { NgbModal,NgbModalOptions,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile,filter,map,mergeMap } from "rxjs/operators";

import { environment } from "src/environments/environment";

import {
    FvmsCommonService
    ,FvmsApiAuthService
} from "src/app/shared/service";
import { LoadingSpinModalComponent } from "src/app/layouts/loading.spin.modal/loading.spin.modal.component";

@Component({
    selector: 'app-full-layout'
    ,templateUrl: './full.component.html'
    ,styleUrls: ['./full.component.scss']
})
export class FullComponent implements OnInit,OnDestroy {
    public config: PerfectScrollbarConfigInterface = {};
    tabStatus = 'justified';

    public isCollapsed = false;

    public innerWidth: any;
    public defaultSidebar: any;
    public showSettings = false;
    public showMobileMenu = true;
    public expandLogo = false;
    public isMenu:boolean = false;
    sideBarType:string = "menu";
    currentUserInfo:any;
    apiType:string;

    options = {
        theme: 'light',
        dir: 'ltr',
        layout: 'vertical',
        sidebartype: 'full',
        sidebarpos: 'fixed',
        headerpos: 'fixed',
        boxed: 'full',
        navbarbg: 'skin6',
        sidebarbg: 'skin5',
        logobg: 'skin6'
    };

    isContinue:boolean = true;
    modalRef:any;
    private modalConfig:NgbModalOptions = {
        centered:true
        ,size: "xl"
        ,backdrop:"static"
        ,windowClass:"modal-spin"
    };
    public envName:string = environment.name;

    constructor(
        public router: Router
        ,private modalService: NgbModal
        ,private fvmsCommonService: FvmsCommonService
        ,private activatedRoute: ActivatedRoute
        ,private fvmsApiAuthService:FvmsApiAuthService
    ) {
        this.router.events
            .pipe(takeWhile(() => this.isContinue))
            .pipe(filter(event => event instanceof NavigationEnd))
            .pipe(map(() => this.activatedRoute))
            .pipe(
                map(route => {
                    while (route.firstChild) {
                        route = route.firstChild;
                    }
                    return route;
                })
            )
            .pipe(filter(route => route.outlet === 'primary'))
            .pipe(mergeMap(route => route.data))
            .subscribe(event => {
                this.sideBarType = event['sideBarType'];
                this.isMenu = this.sideBarType === 'menu'?true:false
            });

        this.fvmsCommonService.subscribeIsLoading()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(isLoading => {
                // console.log("FullComponent","subscribeIsLoading",isLoading);
                if(isLoading === true){
                    this.showModal();
                }else{
                    this.closeModal();
                }
        });
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.apiType = this.currentUserInfo.apiType;
    }

    Logo() {
        this.expandLogo = !this.expandLogo;
    }

    ngOnInit() {
        if (this.router.url === '/') {
            this.router.navigate(['/starter']);
        }
        this.defaultSidebar = this.options.sidebartype;
        this.handleSidebar();
    }

    ngOnDestroy() {
        this.isContinue = false;
        this.fvmsCommonService.setIsLoading(false);
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.handleSidebar();
    }

    handleSidebar() {
        this.innerWidth = window.innerWidth;
        switch (this.defaultSidebar) {
            case 'full':
            case 'iconbar':
                if (this.innerWidth < 1170) {
                    this.options.sidebartype = 'mini-sidebar';
                } else {
                    this.options.sidebartype = this.defaultSidebar;
                }
            break;

            case 'overlay':
                if (this.innerWidth < 767) {
                    this.options.sidebartype = 'mini-sidebar';
                } else {
                    this.options.sidebartype = this.defaultSidebar;
                }
            break;

            default:
        }
    }

    toggleSidebarType() {
        this.showMobileMenu = !this.showMobileMenu;
        switch (this.options.sidebartype) {
            case 'full':
            case 'iconbar':
                // this.options.sidebartype = 'mini-sidebar';
                this.options.sidebartype = 'overlay';
            break;

            case 'overlay':
                if(this.showMobileMenu === true){
                    this.options.sidebartype = this.defaultSidebar;
                }
            break;

            case 'mini-sidebar':
                if (this.defaultSidebar === 'mini-sidebar') {
                    this.options.sidebartype = 'full';
                } else {
                    this.options.sidebartype = this.defaultSidebar;
                }
            break;

            default:
        }
        this.fvmsCommonService.setToggleSideMenu(this.defaultSidebar)
    }

    showModal(){
        // this.closeModal();
        if(!this.modalRef){
            this.modalRef = this.modalService.open(
                LoadingSpinModalComponent
                ,this.modalConfig
            );
            
            this.modalRef.result.then(
                    (result) => {
                        // console.log("FullComponent","show",result);
                    }
                    ,(reason) => {
                        // console.error("FullComponent","show",reason);
                    }
                );
        }
    }

    closeModal(){
        try{
            if(this.modalRef){
                this.modalRef.close({
                    "type":"cancel"
                });
                this.modalRef = null;
            }
        }catch(ex){
            console.error("FullComponent","close",ex);
        }
    }
}
